<template>
  <div>
    <el-select
      v-model="time"
      size="large"
      :disabled="isDisabled"
      :placeholder="title"
      filterable
      @change="onTimeSelection"
    >
      <template slot="prefix">
        <span>{{ title }}</span>
      </template>
      <el-option
        v-for="(item, index) in items"
        :key="index"
        :disabled="item.disabled"
        :label="formatTime(item.value)"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { parseTime, compareTime, nextTime } from "@/globals/globals.js";

export default {
  props: {
    start: { required: true },
    end: { required: true },
    step: { required: true },
    minTime: { required: false },
    title: { required: true },
    isDisabled: { required: false },
    value: { required: false }
  },
  data() {
    return {
      time: "",
      input: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.time = val;
        } else if (val === "") {
          this.time = "";
        }
      }
    }
  },

  computed: {
    items() {
      const start = this.start;
      const end = this.end;
      const step = this.step;
      const result = [];
      if (start && end && step) {
        let current = start;
        while (compareTime(current, end) <= 0) {
          result.push({
            value: current,
            disabled:
              compareTime(current, this.minTime || "-1:-1") <= 0 ||
              compareTime(current, this.maxTime || "100:100") >= 0
          });
          current = nextTime(current, step);
        }
        result.push({
          value: end,
          disabled:
            compareTime(current, this.minTime || "-1:-1") <= 0 ||
            compareTime(current, this.maxTime || "100:100") >= 0
        });
      }
      return result;
    }
  },

  methods: {
    formatTime(time) {
      let { hours, minutes } = parseTime(time);
      let AMorPM = "AM";
      if (hours >= 0 && hours <= 24 && minutes >= 0 && minutes <= 60) {
        if (hours >= 12) AMorPM = "PM";
        hours = hours % 12;

        if (hours === 0) {
          hours = 12;
        }
      }
      return `${hours.toString().length === 1 ? "0" + hours : hours}:${
        minutes.toString().length === 1 ? "0" + minutes : minutes
      } ${AMorPM}`;
    },

    onTimeSelection() {
      this.$emit("onTimeSelected", this.time);
    }
  }
};
</script>
